import { executeRequest, Request } from '@jfs/network'
import { getAppLoginRequestBody } from './../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { sitConfigPreAuth } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const ApiAuth = (mobileNumber: string, tokens: any) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.APPAuth,
    method: 'POST',
    config: sitConfigPreAuth(tokens),
    body: getAppLoginRequestBody(mobileNumber),
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { ApiAuth }
